import React from 'react';
import { get, isEqual } from 'lodash';

import APIRequest from '../api_request';
import BrandCard from '@reverbdotcom/commons/src/components/brand_card';
import ListingsStore, { State as ListingsStoreState } from './listings_store';
import URLHelpers from '../shared/url_helpers';
import mapStateToProps from '../map_state_to_props';
import ParamsBuilder from './params_builder';
import QueryParamsUtil from '../../reverb-js-common/query_params_util';
import { Location } from 'history';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

interface Props {
  heading: string;
  brands: Brand[];
  maxBrandCount?: number;
  filterMode?: boolean;
  location?: Location;
}

interface State {
  brandApiResponse?: any;
}

interface Brand {
  name: string;
  slug: string;
  imageUrl?: string;
}

export class RelatedBrandsRow extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = { brands: [], maxBrandCount: 4, filterMode: false };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchBrandImages();
  }

  componentDidUpdate(prevProps) {
    if (isEqual(this.props.brands, prevProps.brands)) { return; }

    this.fetchBrandImages();
  }

  limitedBrands() {
    return this.props.brands.slice(0, this.props.maxBrandCount);
  }

  slugs() {
    return this.limitedBrands().map(brand => brand.slug);
  }

  fetchBrandImages() {
    if (!this.limitedBrands() || !this.limitedBrands().length) { return; }

    const url = URLHelpers.brandsApi();

    return APIRequest.V3.get(url, { slugs: this.slugs() }).then((res) => {
      this.setState({ brandApiResponse: res });
    });
  }

  imageForBrand(brand) {
    if (!this.state.brandApiResponse) { return null; }

    const apiBrand = this.state.brandApiResponse.brands.find((apiBrand) => {
      return brand.name === apiBrand.name;
    });
    if (!apiBrand) { return null; }

    return get(apiBrand, '_links.card_wide_image.href');
  }

  brandCardLink(slug) {
    if (!this.props.filterMode) { return URLHelpers.brandPath(slug); }

    const newParams = ParamsBuilder.set(this.props.location.query, { make: slug });

    return `${this.props.location.pathname}${QueryParamsUtil.queryParamsForUrl(newParams)}`;
  }

  renderBrandCard(brand) {
    return (
      <BrandCard
        key={brand.slug}
        brand={brand}
        linkOverride={this.brandCardLink(brand.slug)}
      />
    );
  }

  renderBrandCards() {
    const cards = this.limitedBrands().map((brand) => {
      return this.renderBrandCard(brand);
    });

    return (
      <Tiles
        largeTiles
        centered
        singleRow={this.limitedBrands.length < 5}
      >
        {cards}
      </Tiles>
    );
  }

  render() {
    if (!this.limitedBrands().length) { return null; }

    return (
      <div className="scaling-mt-3">
        <OverflowingRow
          title={this.props.heading}
          centeredTitle
        >
          {this.renderBrandCards()}
        </OverflowingRow>
      </div>
    );
  }
}

function mapper() {
  const listingState = ListingsStore.getState() as ListingsStoreState;
  const filters = get(listingState, 'response.facets.filters');
  if (!filters) { return null; }

  const makes = filters.find(f => f.name === 'makes');
  if (makes) {
    const brands = makes.options.map((brand) => {
      return { name: brand.text, slug: brand.query_params.make };
    });

    return { brands };
  }
}

export default mapStateToProps({
  mapper, stores: [ListingsStore],
})(RelatedBrandsRow, 'RelatedBrandsRow');
